import DefaultLayout from '../../layout/DefaultLayout';
import InitialStockFormSection from '../../components/inventory/InitialStock/InitialStockFormSection';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';

const InitialStock = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
        <InitialStockFormSection />
    </DefaultLayout>
  );
};

export default InitialStock;
